export const img_url = `https://donerightaway.com/jiff-done-backend/public/`